export class GetLeaderboardData {
  static readonly type = '[Leaderboard] Get leaderboard data';
}
